<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Email Template Variables</h4>
            <p class="category">Please update the details below to change your automatic email settings.</p>
          </div>
          <div class="card-content">
            <form method="get" action="/" class="form-horizontal">
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Days to Wait</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.email_content.invite_wait_period" class="form-control">
                    <span class="help-block">Days to wait after product purchase before sending review request email.</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Coupon Code</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.email_content.coupon_code" class="form-control">
                    <span class="help-block">Coupon Code as a thank you for leaving a review (please create in shopify).</span>
                  </div>
                </div>
              </fieldset>

              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Discount Description</label>
                  <div class="col-sm-10">
                    <input type="text" v-model="business.email_content.discount_text" class="form-control">
                    <span class="help-block">Description of discount provided by Coupon Code.</span>
                  </div>
                </div>
              </fieldset>

              <button type="submit" @click.prevent="persistBusiness()" class="btn btn-fill btn-info">Save</button>
            </form>
          </div>
        </div>  <!-- end card -->
      </div> <!-- end col-md-12 -->
    </div>

  </div>
</template>
<script>
  import axios from 'axios'
  import swal from 'sweetalert2'

  export default {
    data () {
      return {
        axios_post_config: {
          headers: {
            'Content-Length': 0,
            'Content-Type': 'text/plain'
          },
          responseType: 'text'
        },
        business: {
          email_content: {
            invite_waite_perior: '',
            coupon_code: '',
            discount_text: ''
          }
        },
        loading: false
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.registerForm, isValid)
        })
      },
      fetchBusiness: function (businessUrl) {
        this.$http.get('https://api.vyoo.io/v1/business/?url=' + businessUrl)
        .then(function (response) {
          console.log(response.data)
          this.business = response.data
        })
      },
      persistBusiness2: function () {
        this.$http.post('https://api.vyoo.io/v1/business/', this.business).then(function (response) {
          console.log('Success!:', response.message)
          this.loading = false
        }, function (response) {
          console.log('Error!:', response.data)
          this.loading = false
        })
      },
      persistBusiness: function () {
        axios.post('https://api.vyoo.io/v1/business/', this.business, this.axios_post_config)
        .then(function (response) {
          console.log('saved successfully')
          swal.fire({
            title: `Saved`,
            text: 'Your email settings have been saved',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          })
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.fetchBusiness('angelos-this-n-that.myshopify.com')
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/EmailTemplates.vue